// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { toast } from "react-toastify";

import { ApplicationSessionContext } from "./ApplicationSessionContext";

import { UserService } from "../../entities/User";

import { privateApi, publicApi } from "../../api";
import { useAxios } from "../../utils/axios";

export type ApplicationSessionContextProviderProps = {
	/** Primary content. */
	children?: React.ReactNode;
};

// eslint-disable-next-line max-len
export type ApplicationSessionContextProviderType =
	React.ComponentType<ApplicationSessionContextProviderProps>;

export const ApplicationSessionContextProvider: ApplicationSessionContextProviderType =
	(props: ApplicationSessionContextProviderProps) => {
		const { children } = props;

		const { Provider } = ApplicationSessionContext;

		const [user] = UserService.queryUser();

		const { response } = useAxios(user);

		React.useEffect(() => {
			const responseId = privateApi.interceptors.response.use(
				response.data,
				response.error,
			);

			return () => {
				privateApi.interceptors.response.eject(responseId);
			};
		}, [user]);

		return React.useMemo(
			() => (
				<Provider
					value={{
						user,
					}}
				>
					{children}
				</Provider>
			),
			[user, children],
		);
	};
